import './loader.scss'

const Loader = ({isLoading, onClick}) => {

    return (
        <div className="loader overlay medium ripple" aria-role="alert" onClick={onClick}>
            <span className="visually-hidden">Loading please wait</span>
        </div>
    )
}

export default Loader;